import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Paper,
  Typography,
  Link,
} from "@material-ui/core";
import {
  formatAmount,
  parseDateMDY,
  toCamelCase,
} from "utils/Utils";
import RepaymentInstallmentModal from "./RepaymentInstallmentModal/RepaymentInstallmentModal";

const styles = {
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 24,
    marginBottom: 24,
    boxShadow: "none",
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: "#1E3A5F",
    marginBottom: 24,
  },
  item: {
    marginBottom: 24,
  },
  label: {
    fontSize: 13,
    color: "#6B7280",
    marginBottom: 6,
    fontWeight: 500,
  },
  value: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1F2937",
    wordBreak: "break-word",
  },
};

const Field = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={3}>
    <div style={styles.item}>
      <Typography style={styles.label}>
        {label}
      </Typography>

      <Typography style={styles.value}>
        {value || "NA"}
      </Typography>
    </div>
  </Grid>
);

const RepaymentDetails = ({ repaymentDetails, classes }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Paper style={styles.card}>
        <Typography style={styles.title}>
          Repayment Details
        </Typography>

        <Grid container spacing={2}>
          <Field
            label="Installment Amount"
            value={formatAmount(repaymentDetails?.installmentAmount)}
          />

          <Field
            label="Interest Amount"
            value={formatAmount(repaymentDetails?.interestAmount)}
          />

          <Field
            label="Interest Calculation Type"
            value={toCamelCase(
              repaymentDetails?.interestCalculationType
            )}
          />

          <Field
            label="Interest Rate"
            value={
              repaymentDetails?.interestRate
                ? `${repaymentDetails.interestRate}%`
                : "NA"
            }
          />

          <Field
            label="Product Type"
            value={toCamelCase(repaymentDetails?.productType)}
          />

          <Field
            label="Scheme Code"
            value={repaymentDetails?.schemeCode}
          />

          <Field
            label="Total Amount"
            value={formatAmount(repaymentDetails?.totalAmount)}
          />

          <Field
            label="Days Method"
            value={repaymentDetails?.daysMethod}
          />

          <Field
            label="Disbursal Date"
            value={parseDateMDY(
              repaymentDetails?.disbursalDate
            )}
          />

          <Grid item xs={12} sm={6} md={3}>
            <div style={styles.item}>
              <Typography style={styles.label}>
                Repayment Schedule
              </Typography>

              <Link
                component="button"
                variant="body2"
                onClick={() => setShowModal(true)}
                style={{
                  fontWeight: 600,
                  fontSize: 15,
                }}
              >
                View Schedule
              </Link>
            </div>
          </Grid>
        </Grid>
      </Paper>

      {showModal && (
        <RepaymentInstallmentModal
          installmentData={repaymentDetails?.installments}
          showModal={showModal}
          closeModal={handleClose}
          classesChild={classes}
        />
      )}
    </>
  );
};

Field.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
};

RepaymentDetails.propTypes = {
  classes: PropTypes.object,
  repaymentDetails: PropTypes.object,
};

export default RepaymentDetails;